import { render, staticRenderFns } from "./MemberPeriods.vue?vue&type=template&id=5287f403&scoped=true&lang=pug&"
import script from "./MemberPeriods.vue?vue&type=script&lang=js&"
export * from "./MemberPeriods.vue?vue&type=script&lang=js&"
import style0 from "./MemberPeriods.vue?vue&type=style&index=0&id=5287f403&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5287f403",
  null
  
)

export default component.exports